module.exports = __webpack_public_path__ + "img/settings2.f7e1c990.png";